import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import config from "../config";
import { withRouter } from "react-router-dom";

const twitter_login_url = `${process.env.PUBLIC_URL}/twitter_login.png`;
const google_login_url = `${process.env.PUBLIC_URL}/google_login.png`;

const twitter_login = (
  <div className="title-view-buttons">
    <a href={config.twitter_oauth_url}>
      <img src={twitter_login_url} alt="twitter login" />
    </a>
  </div>
);
const google_login = (
    <div className="title-view-buttons">
        <a href={config.google_oauth_url}>
            <img src={google_login_url} alt="gmail login" />
        </a>
    </div>
);

class LoginView extends Component {
  componentDidMount() {
    if (this.props.match.params.user_id !== void 0) {
      this.props.handleLogin(this.props.match.params.user_id);
      this.props.history.push("/");
    }
  }

  render() {
    
    return (
      <div className="loginView">
        <center>{twitter_login}</center>
        <center>{google_login}</center>
      </div>
    );
  }
}

LoginView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      user_id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  handleLogin: PropTypes.func,
};

export default withRouter(LoginView);
